

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","class":[styles && styles["icon__svg"] || "icon__svg",styles && styles["icon__svg--arrow-down"] || "icon__svg--arrow-down"].join(' '),"fill":"currentColor","width":"80","height":"80"}, rest), [h('undefined', {}, []), h('title', {}, ["arrow_down"]), h('desc', {}, ["Created with Sketch."]), h('g', {"id":"svg-arrow-down-3UG76AF","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}, [h('polygon', {"id":"svg-arrow-down-IKmRp8A","fill":"currentColor","points":"0 20 80 20 40 60"}, [])])]);
};

        